import { UserDto } from "common/models";
import { PropsWithChildren } from "react";
import { AuthRoutes } from "ui/auth/router/AuthRouter.types";
import ProtectedRoute from "ui/router/components/ProtectedRoute/ProtectedRoute";
import useLocationState from "ui/router/hooks/useLocationState";

const UserDetailsInRoute = ({ children }: PropsWithChildren<object>): JSX.Element => {
    const user = useLocationState<UserDto>("user");
    return (
        <ProtectedRoute isAllowed={Boolean(user)} redirectPath={AuthRoutes.REGISTER}>
            {children}
        </ProtectedRoute>
    );
};

export default UserDetailsInRoute;
